import { Anchor } from '@urbaninfrastructure/react-ui-kit';
import styled from 'styled-components';

export const NavLink = styled(Anchor)`
  vertical-align: middle;
  text-decoration: none;
  cursor: pointer;
  user-select: none;
  color: rgb(255, 255, 255);
  background-color: ${({ theme }) => theme.colors.primary};
  display: inline-block;
  font-size: ${({ theme }) => theme.fontSizes[2]};
  line-height: 1.45;
  padding: 8px 32px;
  font-family: ${({ theme }) => theme.fonts.heading};
  text-align: center;
  border-width: 2px;
  border-style: solid;
  border-radius: 9999px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0s !important;
}`;
